export function horizontalResize(callBack) {
    let previousWidth = window.innerWidth;
    let previousHeight = window.innerHeight;

    window.addEventListener('resize', () => {
        const currentWidth = window.innerWidth;
        const currentHeight = window.innerHeight;
        if (currentWidth !== previousWidth && currentHeight === previousHeight) {
            previousWidth = currentWidth;
            console.log("svav");
            callBack()// при изменении ширины экрана срабатывает кодбэк-функция
        }
        previousHeight = currentHeight;
    });
}